<template>
  <el-dialog width="600px" title="批量修改售后状态" v-model="isvisible">
    <el-form
      ref="orderFormRef"
      :model="orderForm"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="售后状态" prop="salestatus">
        <el-select
          v-model="orderForm.salestatus"
          placeholder="选择售后状态"
          style="width: 100%"
        >
        <el-option label="未完成" :value="1" />
        <el-option label="已完成" :value="2" />
        <el-option label="已作废" :value="3" />
        </el-select>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="doBatchSaveSaleStatus" :loading="loading" >{{
          loading ? "提交中 ..." : "确认"
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
  <script setup>
import { ref, defineExpose, defineEmits } from "vue";
import { ElMessage } from "element-plus";
import { batchSaveSaleStatus } from "@/api/order/sale";

let timer;

const loading = ref(false);

const emit = defineEmits(["click"]); // 声明触发事件 change

const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const orderFormRef = ref();
const orderForm = ref({
  orderid: "",
  salestatus: "",
});

const saleStatusMethod = (obj) => {
  orderForm.value = {
    orderid: obj.orderid,
  };
  // console.log("orderForm.value---", orderForm.value);
};

defineExpose({ changeVisible, saleStatusMethod });

const doBatchSaveSaleStatus = () => {
  orderFormRef.value.validate((valid) => {
    if (!valid) {
      // ElMessage("请先完善表单数据填写！");
      return;
    }

    let orders = [];
    let orderids = orderForm.value.orderid;

    for (let i = 0; i < orderids.length; i++) {
      orders.push({
        orderid: orderids[i],
        salestatus: orderForm.value.salestatus,
      });
    }
    // console.log("orders---", orders);
    // console.log("orderForm.value---", orderForm.value);

    batchSaveSaleStatus(orders).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          closeDialog()
          emit('click')
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

const closeDialog = () => {
  isvisible.value = false;
  orderFormRef.value.resetFields();
  clearTimeout(timer);
};

//表单验证规则
const rules = ref({
  salestatus: [
    {
      required: true,
      message: "请选择售后状态",
      trigger: "change",
    }
  ]
});
</script>
  <style scoped>
.el-dialog {
  text-align: left;
}
.el-dialog__body {
  padding-top: 15px;
}
</style>